import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import encryptUtility from "../../utility/js/encrypt-utility";
import announcementService from "../js/announcement-service";
import moment from "moment";
import AddFavourite from "../../utility/js/addFav";
//import commonApiService from '../../common/js/common-api-service';
import utility from "@/shared/utility";
import HtmlRichEditorComp from "../../common/html-rich-editor-comp.vue";

export default {
  data: () => ({
    isLoaded: false,
    emailRules: [
      (v) => !!v || "Email is required",
      (v) => /^(?!.*\.\.)(?!.*\s)[A-Za-z0-9]+([._%+-]?[A-Za-z0-9]+)*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,})+$/.test(v) || "Email must be valid",
      (v) => (v && v.toString().length <= 100) || "Maximum 100 characters allowed",
    ],
    userId: encryptUtility.localStorageDecrypt("userID"),
    // form state
    formValid: false,
    otherNotes: false,
    showAdditionalNotesError: false,
    menu1: false,
    menu2: false,
    publishStartDateMenu: false,
    publishStartTimeMenu: false,
    publishEndDateMenu: false,
    publishEndTimeMenu: false,
    publishStartDate: null,
    publishStartTime: null,
    publishEndDate: null,
    publishEndTime: null,
    minPublishEndDate: null,
    maxPublishEndDate: null,
    minPublishStartDate: new Date().toISOString().split("T")[0],
    minAnnouncementDate: null,
    maxAnnouncementDate: null,
    backSlashParent:true,
    backSlash:true,
    route: "",
    pageUrl: "",
    subPageUrl: "",
    mainPage: "",
    subPage: "",
    appPageName: "",
    actionList: [],
    favouriteList: [],
    showAdd: false,
    
    // flags to allow binding with :disabled attributes (kept false by default)
    disableSalesDetails: false,
    disableRMA: false,
    date: "",
    time: "",
    // a simple local list to store created announcements (client-only for now)
    announcements: [],
    // dropdown placeholder
    announcementTypeList: [],
    otherNotesHeaders: [
      {
        text: "Ticket Number",
        align: "start",
        value: "ticket",
        class: "primary customwhite--text",
      },
      {
        text: "Page",
        align: "start",
        value: "page_name",
        class: "primary customwhite--text",
      },
      {
        text: "Other Details",
        align: "start",
        value: "other_details",
        class: "primary customwhite--text",
      },
      {
        text: "Actions",
        align: "start",
        value: "actions",
        class: "primary customwhite--text",
      },
    ],
    otherNotesList: [],
    // submit object must match the user's requested JSON shape
    submitObj: {
      user_id: Number(encryptUtility.localStorageDecrypt("userID")),
      announcement_id: 0,
      announcement_type_id: "",
      announcement_name: "",
      message_data: "",
      contact_name: "",
      support_email: "",
      announcement_date: "",
      phone: "",
      // enabled: true,
      duration: "",
      details_json: "",
      publish_start_datetime: null,
      publish_end_datetime: null,
      announcement_html: "",
    },
    detailsObj: {
      ticket: "",
      page_name: "",
      other_details: "",
    },
    detailsId: "",
    // small set of validation rules used by the template
    required: [(v) => !!v || "This field is required"],
    announcementTypeRule:[
      (v) => !!v || "This field is required"],

    // validation helpers
    max20Rule: [
      (v) =>
        !v ||
        (v && v.toString().length <= 20) ||
        "Maximum 20 characters allowed",
    ],
    hourRule: [
      (v) => !!v || "This field is required",
      (v) => (v && !isNaN(v) && v >= 0 && v <= 24) || "Hour must be between 0 and 24",
    ],
    max50Rule: [
      (v) => !!v || "This field is required",
      (v) => (v && v.toString().length <= 50) || "Maximun 50 characters allowed",
    ],
    max100Rule: [
      (v) => !!v || "This field is required",
      (v) => (v && v.toString().length <= 100) || "Maximun 100 characters allowed",
    ],
    max200Rule: [
      (v) => !!v || "This field is required",
      (v) => (v && v.toString().length <= 200) || "Maximun 200 characters allowed",
    ],
     max500Rule: [
      (v) =>
        !v || !!v || "This field is required",
        (v) => (v && v.toString().length <= 500) ||
        "Maximum 500 characters allowed",
    ],
    phoneRule: [
      (v) => !!v || "Phone number is required",
      (v) => /^[0-9\s\-()]+$/.test(v) || "Phone number must contain only numbers",
      (v) => (v && v.toString().length <= 20) || "Max Length must be 20 characters or less"
    ],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    console.log(data);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
  },
  async mounted() {
    this.getAnnouncementType();
    if (this.$route?.params?.id !== undefined) {
      this.detailsId = atob(this.$route?.params?.id);
      let announcementDetails =
        await announcementService.getAnnouncementDetails(
          "get",
          this.userId,
          this.detailsId
        );
      this.submitObj = {
        user_id: announcementDetails.user_id,
        announcement_id: announcementDetails.announcement_id,
        announcement_type_id: announcementDetails.announcement_type_id,
        announcement_name: announcementDetails.announcement_name,
        message_data: announcementDetails.message_data,
        contact_name: announcementDetails.contact_name,
        support_email: announcementDetails.support_email,
        phone: announcementDetails.phone,
        announcement_date: announcementDetails.announcement_date,
        // enabled: announcementDetails.enabled,
        duration: announcementDetails.duration,
        publish_start_datetime: announcementDetails.publish_start_datetime,
        publish_end_datetime: announcementDetails.publish_end_datetime,
        announcement_html: announcementDetails.details?.[0]?.announcement_html || announcementDetails.announcement_html || "",
      };      
      this.otherNotesList = announcementDetails.details;
      this.otherNotesList?.forEach((element) => {
        element.tempId = Math.random().toString(10).substr(2, 9);
      });
      this.otherNotes = (announcementDetails.details?.[0]?.announcement_html) ? true : false;
      this.date = moment(this.submitObj.announcement_date).format("YYYY-MM-DD");
      this.time = moment(this.submitObj.announcement_date).format("HH:mm");
      
      // Load publish start datetime
      if (this.submitObj.publish_start_datetime) {
        this.publishStartDate = moment(this.submitObj.publish_start_datetime).format("YYYY-MM-DD");
        this.publishStartTime = moment(this.submitObj.publish_start_datetime).format("HH:mm");
      }
      
      // Load publish end datetime
      if (this.submitObj.publish_end_datetime) {
        this.publishEndDate = moment(this.submitObj.publish_end_datetime).format("YYYY-MM-DD");
        this.publishEndTime = moment(this.submitObj.publish_end_datetime).format("HH:mm");
      }
    } else {
      // Initialize date to current date when adding new announcement
      this.date = moment().format("YYYY-MM-DD");
      this.time = moment().format("HH:mm");
    }
    // Initialize publish end date constraints
    this.setPublishEndDate();
    this.setMaxPublishEndDate();
    this.setAnnouncementDateConstraints();
    this.isLoaded = true;
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.date
        ? moment(this.date).format("MM/DD/YYYY")
        : moment(new Date().getTime()).format("MM/DD/YYYY");
    },
    computedPublishStartDateFormatted() {
      return this.publishStartDate
        ? moment(this.publishStartDate).format("MM/DD/YYYY")
        : "";
    },
    computedPublishEndDateFormatted() {
      return this.publishEndDate
        ? moment(this.publishEndDate).format("MM/DD/YYYY")
        : "";
    },
    additionalNotesRules() {
      // When switch is ON, the field is required
      // When switch is OFF, no validation rules
      return this.otherNotes 
        ? [(v) => !!v || "Additional notes are required when enabled"]
        : [];
    },
  },
  methods: {
    async onClickSubmitAnnouncement() {
      // validate the form and save the announcement loca
      if (!this.$refs.announcementForm.validate()) {
        return;
      }
      // If otherNotes is ON, announcement_html is required
      if (this.otherNotes && !this.submitObj.announcement_html) {
        this.showAdditionalNotesError = true;
        return;
      }
      this.showAdditionalNotesError = false;
      
      // Validate announcement date and time are within publish start and end datetime range
      if (this.publishStartDate && this.publishStartTime && this.date && this.time) {
        const announcementDateTime = new Date(`${this.date}T${this.time}:00`);
        const publishStartDateTime = new Date(`${this.publishStartDate}T${this.publishStartTime}:00`);
        
        if (announcementDateTime < publishStartDateTime) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Announcement date and time must be on or after the publish start date and time.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          return;
        }
      }
      
      if (this.publishEndDate && this.publishEndTime && this.date && this.time) {
        const announcementDateTime = new Date(`${this.date}T${this.time}:00`);
        const publishEndDateTime = new Date(`${this.publishEndDate}T${this.publishEndTime}:00`);
        
        if (announcementDateTime > publishEndDateTime) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Announcement date and time must be on or before the publish end date and time.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          return;
        }
      }
      
      {
        // assign a simple id if not present (client-only behavior)
        this.submitObj.details_json = JSON.stringify(this.otherNotesList);
        this.submitObj.announcement_date = utility.inputDateFormat(
          this.computedDateFormattedMomentjs,
          this.time + ":00"
        );
        
        // Format publish start datetime
        if (this.publishStartDate && this.publishStartTime) {
          this.submitObj.publish_start_datetime = utility.inputDateFormat(
            moment(this.publishStartDate).format("MM/DD/YYYY"),
            this.publishStartTime + ":00"
          );
        } else {
          this.submitObj.publish_start_datetime = null;
        }
        
        // Format publish end datetime
        if (this.publishEndDate && this.publishEndTime) {
          this.submitObj.publish_end_datetime = utility.inputDateFormat(
            moment(this.publishEndDate).format("MM/DD/YYYY"),
            this.publishEndTime + ":00"
          );
        } else {
          this.submitObj.publish_end_datetime = null;
        }
        
        // eslint-disable-next-line no-console
        let resp = await announcementService.postAnnouncementUpsert(
          "post",
          this.submitObj,
          true
        );
        console.log(resp);
        this.$router.push({ path: "/announcement" });
        // reset the form to defaults (keep user_id)
        this.resetAnnouncementForm();
      }
    },
    
    async onChangeAnnoucementType(){
      let response = await announcementService.validateAnnouncement(
        "get",
        this.submitObj.announcement_type_id,
        false
      );
      if(!response){
        this.submitObj.announcement_type_id="";
      }
    },

    resetAnnouncementForm() {
      // reset to defaults; keep user_id unless explicitly requested
      this.submitObj = {
        announcement_id: 0,
        announcement_type_id: "",
        announcement_name: "",
        message_data: "",
        contact_name: "",
        support_email: "",
        announcement_date: "",
        phone: "",
        // enabled: true,
        duration: "",
        details_json: "",
        publish_start_datetime: null,
        publish_end_datetime: null,
        announcement_html: "",
      };
      this.publishStartDate = null;
      this.publishStartTime = null;
      this.publishEndDate = null;
      this.publishEndTime = null;
      this.otherNotesList = [];
      this.otherNotes = false;
      this.detailsObj = {
        ticket: "",
        page_name: "",
        other_details: "",
      };
      if (this.$refs.announcementForm)
        this.$refs.announcementForm.resetValidation();
      this.formValid = false;
    },
    async getAnnouncementType() {
      let response = await announcementService.getAnnounceTypeData(
        "get",
        this.userId
      );
      this.announcementTypeList = response;
    },
    setPublishEndDate() {
      // Publish end date minimum is the publish start date
      if (this.publishStartDate) {
        this.minPublishEndDate = this.publishStartDate;
      } else {
        // If no publish start date, default to today
        this.minPublishEndDate = new Date().toISOString().split("T")[0];
      }
    },

    setMaxPublishEndDate() {
      // Allow publish end date up to 1 year from today
      const maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() + 1);
      this.maxPublishEndDate = maxDate.toISOString().substr(0, 10);
    },
    setAnnouncementDateConstraints() {
      // Announcement date can be same as or after publish start date
      if (this.publishStartDate) {
        this.minAnnouncementDate = this.publishStartDate;
      } else {
        this.minAnnouncementDate = null;
      }
      
      // Announcement date can be same as or before publish end date
      if (this.publishEndDate) {
        this.maxAnnouncementDate = this.publishEndDate;
      } else {
        this.maxAnnouncementDate = null;
      }
    },

    onClickAddOtherNotes() {
      if (!this.$refs.detailsForm.validate()) {
        return;
      } else {
        this.otherNotesList.push({
          ticket: this.detailsObj.ticket,
          page_name: this.detailsObj.page_name,
          other_details: this.detailsObj.other_details,
          tempId: Math.random().toString(36).substr(2, 9),
        });
        this.detailsObj.ticket = "";
        this.detailsObj.page_name = "";
        this.detailsObj.other_details = "";
        this.$refs.detailsForm.resetValidation();
      }
    },
    onClickDeleteOtherNotes(item) {
      this.otherNotesList = this.otherNotesList.filter(
        (i) => i.tempId !== item.tempId
      );
    },
    onClickEditOtherNotes(item) {
      this.detailsObj.ticket = item.ticket;
      this.detailsObj.page_name = item.page_name;
      this.detailsObj.other_details = item.other_details;
      this.otherNotesList = this.otherNotesList.filter(
        (i) => i.tempId !== item.tempId
      );
    },
  },
  watch: {
    // Clear error when user starts typing in announcement_html
    'submitObj.announcement_html'(newVal) {
      if (newVal && this.showAdditionalNotesError) {
        this.showAdditionalNotesError = false;
      }
    },
    // Clear error when switch is turned off
    otherNotes(newVal) {
      if (!newVal) {
        this.showAdditionalNotesError = false;
      }
    },
    
    // Update publish end date minimum when publish start date changes
    publishStartDate() {
      this.setPublishEndDate();
      this.setAnnouncementDateConstraints();
    },
    // Update announcement date constraints when publish end date changes
    publishEndDate() {
      this.setAnnouncementDateConstraints();
    },
  },
  components: {
    breadcrumbComp,
    HtmlRichEditorComp,
  },
};
